import { render, staticRenderFns } from "./DistributionEvaluation.vue?vue&type=template&id=9df27ee2"
import script from "./DistributionEvaluation.vue?vue&type=script&lang=js"
export * from "./DistributionEvaluation.vue?vue&type=script&lang=js"
import style0 from "./DistributionEvaluation.vue?vue&type=style&index=0&id=9df27ee2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports